<template>
    <div class="position-box">
        <div class="head">
            <div class="back-box" @click="goBack"><img class="icon" src="@/assets/icon_back.png" alt="back"></div>
            <div>{{this.$t('langNew.aqsz')}}</div>
        </div>
        <div class="cont-box">
            <ul class="list-box">
                <!-- 修改提款密码 -->
                <router-link class="list" tag='li' to='/emailBind' v-if="!isMail">
                    <div class="list-text">{{$t('langNew.yxbd')}}</div>
                    <img class="arrow" src="@/assets/more2.png" alt="">
                </router-link>
                <router-link class="list" tag='li' v-else>
                    <div class="list-text">{{$t('langNew.yxbd')}}</div>
                    <div>{{isMail}}</div>
                </router-link>
                <!-- 修改登录密码 -->
                <router-link class="list" tag='li' to='/setWithdrawPwd'>
                    <div class="list-text">{{this.$t('sztxmm.t8')}}</div>
                    <img class="arrow" src="@/assets/more2.png" alt="">
                </router-link>
            </ul>
        </div>
    </div>
</template>
<script>
export default {
    name: 'safety',
    data () {
        return {
            data: '',
            isMail: '',
        }
    },
    mounted() {
      this.getCenterLevel();
    },
    methods: {
        goBack(){
            this.$router.push('/index');
        },
        getCenterLevel(){
            let that = this;
            let params = {
                level: 1
            }
            this.$ajax.get('/web/getCenterLevel',{params}).then((res) => {
              let resData = res.data.data;
              if(res.data.code == 1000){
                setTimeout(()=>{
                  that.$router.push('/index');
                },1000)
              }else{
                that.isMail = resData.email;
              }
            }).catch(function(err){
                console.log(err)
            })
        },
    }
}
</script>
<style scoped>
    .position-box{
        position: absolute;
        left: 0;
        top: 0;
        bottom: 0;
        width: 100%;
        height: auto;
        color: #cecece;
        font-size: .32rem;
        background: url('../assets/element-background.png') no-repeat center center;
        background-size: cover;
        overflow: hidden;
    }
    .head{
        position: fixed;
        top: 0;
        width: 100%;
        height: 1.2rem;
        font-size: .52rem;
        line-height: 1.2rem;
        text-align: center;
    }
    .head .icon{
        position: absolute;
        left: .3rem;
        top: .3rem;
        width: .32rem;
        height: .6rem;
    }
    .cont-box{
        position: absolute;
        left: 0;
        right: 0;
        top: 1.2rem;
        bottom: 0;
        width: auto;
        height: auto;
        overflow: hidden;
    }
    .list-box{
        padding: .12rem .3rem 0;
    }
    .list-box .list{
        display: flex;
        align-items: center;
        padding: .7rem 0 .58rem;
        font-size: .48rem;
        border-bottom: 1px solid #858585;
    }
    .list-box .list-text{
        flex: 1;
    }
     .list-box .list .arrow{
        width: .2rem;
        height: .4rem;
    }
</style>



// WEBPACK FOOTER //
// src/pages/safety.vue